import { CustomButton } from '@/shared/ui/components';
import { Checkbox, Modal } from 'antd';
import { useMarkAddressedModal } from './useMarkAddressedModal';
import './markAddressedStudy.scss';

export interface MarkAddressedModalProps {
  isOpen: boolean;
  onCloseModal: () => void;
  onClickMarkAddressed: (isIgnoreChecked: boolean) => void;
  loading: boolean;
}

const MarkAddressedModal = ({
  isOpen,
  onCloseModal,
  onClickMarkAddressed,
  loading,
}: MarkAddressedModalProps) => {
  const { isIgnoreChecked, setIsIgnoreChecked } = useMarkAddressedModal({ isOpen });
  return (
    <Modal
      width={400}
      open={isOpen}
      rootClassName="mark-addressed-modal"
      footer={null}
      destroyOnHidden
      title="Mark issue as addressed?"
      classNames={{ header: 'mark-addressed-body__title' }}
    >
      <div className="mark-addressed-body">
        <div className="mark-addressed-body__content">
          You&apos;ve applied the recommended solution. We&apos;ll continue monitoring this issue.
          If the study violates this issue again, it will reappear in the Flagged Studies tab.
        </div>
        <Checkbox
          className="mark-addressed-body__checkbox"
          checked={isIgnoreChecked}
          onChange={(e) => setIsIgnoreChecked(e.target.checked)}
        >
          Ignore this flagged issue for this study.
        </Checkbox>
        <div className="mark-addressed-body__action">
          <CustomButton
            disabled={loading}
            onClick={onCloseModal}
            size="middle"
            type="outline"
            style="neutral"
          >
            Cancel
          </CustomButton>
          <CustomButton
            loading={loading}
            onClick={() => onClickMarkAddressed(isIgnoreChecked)}
            size="middle"
          >
            Mark as Addressed
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};

export default MarkAddressedModal;
